const config = {
    1: {
        slidesPerView: 3.33333,
        spaceBetween: 35,
        centeredSlides: true,
        loop:true,
        breakpoints: {
            1: {
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            500: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 3.33333,
       
                spaceBetween: 35,
            },
            2500: {
                slidesPerView: 4,
                centeredSlides: false
            }
        }
    },

    2: {
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            500: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 3,
       
                spaceBetween: 30,
            }
        }
    },

    3:{
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 20,
            }
        }
    },
    4:{
        slidesPerView: 1,
        spaceBetween: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 1,
            }
        }
    },
    5: {
        slidesPerView: 4,
        spaceBetween: 45,
        centeredSlides: false,
        loop:true,
        navigation: {
            nextEl: "instagram-feed .swiper-button-next",
            prevEl: "instagram-feed .swiper-button-prev",
          },
        breakpoints: {
            1: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            500: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 3,
       
                spaceBetween: 45,
            },
            1023: {
                slidesPerView: 4,
       
                spaceBetween: 45,
            },
            1512: {
                slidesPerView: 4,
       
                spaceBetween: 45,
            },
            2500: {
                slidesPerView: 4,
                centeredSlides: false
            }
        }
    },
}


class CustomSlider extends HTMLElement {
    constructor() {
        super();
        this.config = config[this.getAttribute('data-slider-config')];
    }

    connectedCallback() {
        this.update();
    }
    update() {
        this.swiper = new Swiper(this.querySelector(".swiper"), this.config);
    }
}   

customElements.define('custom-slider', CustomSlider);